export default {
  detail: '/gateway/capp/courier_operations/signWeek/detail',
  rule: '/gateway/capp/courier_operations/signWeek/rule'
}
